import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { msgMaxLength, msgRequired } from '@/utils';
import { trans } from '@/i18n';

export const schema = yup.object({
  name: yup
    .string()
    .max(255, msgMaxLength(255, trans('note.name')))
    .required(msgRequired('note.name'))
    .test('empty', msgRequired('note.name'), (value) => {
      return value ? value.trim() !== '' : false;
    }),
  memo: yup
    .string()
    .nullable()
    .max(512, msgMaxLength(512, trans('note.memo'))),
});

const updateNoteYup = yupResolver(schema) as any;
export default updateNoteYup;
